import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import type { SkeletonProps } from '../types';
import { CardListSkeleton } from './CardListSkeleton';

export const YourAgentsSkeleton = ({ testId }: SkeletonProps): React.JSX.Element => (
	<Stack space="space.400">
		<CardListSkeleton count={4} showHeading testId={testId ? `${testId}--owned` : undefined} />
		<CardListSkeleton count={4} showHeading testId={testId ? `${testId}--starred` : undefined} />
	</Stack>
);
